/**
 * Query keys for the contracts table, which renders both unscoped and scoped
 * to a single entity.
 */
export const contractKeys = {
  all: ["contracts"],
  lists: () => [...contractKeys.all, "list"],
  list: ({ entityId = null } = {}) => [...contractKeys.lists(), { entityId }],
};
